import { distanceFormatter } from '@lifedot/utils'
import { typography } from '@lifedot/styles/typography'
import * as React from 'react'

interface CemeteryAccessProps {
  cityName: string
  prefectureName: string
  station: {
    name: string | null
    distance: number | null
  }
}

export const CemeteryAccess: React.FC<CemeteryAccessProps> = ({
  cityName,
  prefectureName,
  station
}) => {
  return (
    <p css={typography.textS}>
      {prefectureName} / {cityName}
      {station.name && station.distance && (
        <>
          <br />
          {station.name}駅から{distanceFormatter(station.distance)}
        </>
      )}
    </p>
  )
}
